import { femaleQuestionMedium, maleQuestionMedium, bulbMedium } from '@/assets/icons';
import {
  ALWAYS_DO_WHAT_ALWAYS_DID,
  ALWAYS_DO_WHAT_ALWAYS_DID_SOURCE,
  FIND_FAULT,
  FIND_FAULT_SOURCE,
} from './quotes';

const NO_BLAME = `
<div class="ia-sensei-quote">
  <span class="quote">«${FIND_FAULT}"</span>
  <br>
  <span class="author">${FIND_FAULT_SOURCE}</span>
</div>
<h2 class="basic-sub-title">
  Céntrese en el proceso, y no en las personas
</h2>
<p>
  Querer saber quién ha hecho mal las cosas es humano. Sin embargo, esto genera una mala relación entre el superior y sus subordinados.<br>
  El ser humano evita resultar humillado, al tratarse de uno de sus mayores temores;
  por eso, ante la posibilidad de que puedan reprocharnos haber cometido un error
  intentar ocultarlo es un comportamiento totalmente normal.
</p>
<div class="ia-sensei-question">
  <div class="question-decoration"></div>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${femaleQuestionMedium}"></path></svg>
  <span class="question">Si no le digo a alguien que no lo ha hecho bien, nunca podrá mejorar...</span>
</div>
<p>
  Estamos efectivamente ante un error clásico.
</p>
<div class="ia-sensei-example">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${bulbMedium}"></path></svg>
  <div class="example-title">Vamos a verlo con un ejemplo:</div>
  Miguel ha cometido un error de principiante al manipular la carretilla:
  Todo el mundo sabe que en la "vía R" hay que conducir las carretillas marcha atrás.
  De lo contrario, pueden acabar bloqueadas al final de la vía, porque las ruedas traseras no pueden girar.<br>
  Por eso, Miguel, que lo había olvidado, se encuentra ahora atascado en una posición muy incómoda, pues no puede
  dar marcha atrás y se ve obligado a pedir ayuda a sus compañeros para vaciar la carretilla y cargarla para sacarla de la vía...
</div>
<br>
<p>
  Sin duda, decirle a Miguel lo que ha hecho mal le ayudará a entender qué hay que hacer para proceder correctamente.<br>
  Pero dejemos de centrarnos en el error para hacerlo en <strong>lo sucedido</strong>:
</p>
<br>
<div class="ia-sensei-example">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${bulbMedium}"></path></svg>
  Un empleado nuevo ha cometido un error porque no había recibido ninguna indicación sobre cómo debía conducir una carretilla por la vía.
</div>
<div class="ia-sensei-question">
  <div class="question-decoration"></div>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${maleQuestionMedium}"></path></svg>
  <span class="question">Mmm, no parece demasiado complicado de resolver. ¿Y si ponemos una señal indicadora a la entrada de la vía R?</span>
</div>
<p>
  Eso es. Y ya ni siquiera será necesario ir a hablar con Miguel para decirle lo mal que lo ha hecho.<br>
  Lejos de eso, Miguel podría estar detrás de la resolución del problema.
  Así, en lugar de sentirse culpable, será consciente de que se preocupan por él y
  contribuirá con una mejora para todos sus compañeros.<br>
  En conclusión, deberemos aprender a analizar <strong>qué ha pasado</strong> y dejar de buscar <strong>culpables</strong>.
</p>
<h2 class="basic-sub-title">
  Destacar las conductas adecuadas y dar ejemplo
</h2>
<p>
  No es fácil conseguir un entorno en el que "nadie señale con el dedo". De hecho, más que nada, se trata de un reto de índole cultural.
  Pero no podemos esperar que sean los demás quienes den el primer paso. Podemos empezar interesándonos por los procesos
  en lugar de por las personas, haciendo sugerencias y expresándolas voz alta, siendo sinceros y destacando la labor de quienes hagan las cosas como nosotros.<br>
  Si cree que este tipo de entorno requiere un cambio de cultura, solo será posible lograrlo
  animándose los unos a los otros, apoyándose mutuamente y mostrando cómo se asumen las responsabilidades.
</p>
<div class="ia-sensei-quote">
  <span class="quote">"${ALWAYS_DO_WHAT_ALWAYS_DID}"</span>
  <br>
  <span class="author">${ALWAYS_DO_WHAT_ALWAYS_DID_SOURCE}</span>
</div>
<p>
  Esto resulta más fácil de decir que de hacer. Por eso, los superiores y jefes de equipo deben establecer las condiciones
  adecuadas para que la gente pueda expresarse. Ofrezca a cada compañero un momento para expresarse cada semana; durante las inspecciones
  sobre el terreno, pregunte a sus compañeros cómo se sienten y, a la hora de solucionar los problemas, pregúnteles cómo les gustaría participar.<br>
  En definitiva, debe crear un entorno en el que los compañeros se sientan en confianza y se ayuden mutuamente.
  Ese es el camino para lograr un entorno en el que "nadie señale con el dedo".
</p>
`;

const NO_BLAME_TITLE = 'No señalar con el dedo';

export default {
  NO_BLAME,
  NO_BLAME_TITLE,
};
